import { Typography } from '@/components/Typography'
import type { UserType } from '@/services/types/mockUser'

import styles from './styles.module.scss'

export interface UserNameWithEmailProps {
  user: Omit<UserType, 'id'>
}

export function UserNameWithEmail({ user }: UserNameWithEmailProps) {
  return (
    <div className={styles.container}>
      <Typography.Text strong>{`${user.givenName} ${user.familyName}`}</Typography.Text>
      <Typography.Text type="secondary">{user.email}</Typography.Text>
    </div>
  )
}
